import Image from "next/image";
import { usePropertyContext } from "../../context";
import ExemptionsAnimationWhite from "public/account/exemptions/exemptions-animation-white.gif";
import { useRouter, useSearchParams } from "next/navigation";
import { sendErrorToWebhook } from "utils/sendWebhook";
import ButtonV2 from "elements/ButtonV2";
import { formatRelativeUrl } from "utils/formatRelativeUrl";

const NARResolved = () => {
	const { setModalToShow, details, fetchPropertyDetails } =
		usePropertyContext();
	const handleSubmit = async () => {
		setModalToShow(undefined);
		onAttemptExit();
	};

	const router = useRouter();
	const searchParams = useSearchParams();

	const onAttemptExit = () => {
		if (!details) return;
		setModalToShow(undefined);
		router.push(
			formatRelativeUrl({
				pathname: `/account/properties/${details.id}`,
				query: {
					...(searchParams.get("onboarding") ? { onboarding: true } : {}),
				},
			})
		);
		fetchPropertyDetails(details.id.toString(), {
			autoOpenNARModal: false,
		}).catch(err => {
			console.error(err);
			sendErrorToWebhook(
				"Error caught in onAttemptExit of Exemptions Survey at the We Go it from here Page: " +
					err
			);
		});
	};

	return (
		<div>
			<div className="exemptions-question-card mt-4">
				<div className="exemptions-intro-animation-box-reversed mt-2">
					<div>
						<p className="lg bold">We’ve got it from here!</p>
						<p className="sm">
							Thanks for updating your exemption application information. We
							will reach out if we need any additional information or materials
							from you.
						</p>
					</div>
					<div className="exemptions-intro-animation">
						<Image
							src={ExemptionsAnimationWhite}
							unoptimized
							alt="Exemptions Table"
							style={{
								maxWidth: "100%",
								height: "auto",
							}}
						/>
					</div>
				</div>
			</div>
			<ButtonV2
				size="large"
				id="account-property-profile-intro-begin"
				onClick={handleSubmit}>
				Finish
			</ButtonV2>
		</div>
	);
};

export default NARResolved;
